import { IELTData, IELTDataSettings } from 'legacy/lut/classes/models/partner360/ELT/IELTData'
import { TEltFormData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { defaultActualValueTypes } from 'legacy/lut/components/widgets/public/partner360/ELT/configs'
import { getForceUpdatedDataFotDifferentEltType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getForceUpdatedDataFotDifferentEltType'
import { getCompanyName } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/requestsHelpers/getCompanyName'
import { getFinancialDataHelper } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/requestsHelpers/getFinancialDataHelper'
import { IForceUpdateData } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IForceUpdateData'
import { IPartnerGroupAdditionalInfo } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IPartnerGroupAdditionalInfo'

import { fetchELTPopulatedData } from '../api/eltData/fetchELTPopulatedData'

interface IGetForceUpdatedForm {
  item: IELTData
  formData: TEltFormData
  partnerId: string
  partnerGroupData: IPartnerGroupAdditionalInfo | null
  fYear: number
  fQuarter: number
  dataSettings: IELTDataSettings
}

export const getForceUpdatedForm = async ({
  item,
  partnerGroupData,
  partnerId,
  fQuarter,
  fYear,
  formData,
  dataSettings,
}: IGetForceUpdatedForm) => {
  const companyName = await getCompanyName({ partnerId, data: item, forceFetch: true })

  const financialData = await getFinancialDataHelper({
    partnerId,
    fYear: fYear,
    groupId: partnerGroupData?.groupId || null,
    forceFetch: true,
    eltType: item.EltType,
    isRollup: formData.IsRollup || 0,
  })

  const populatedData = await fetchELTPopulatedData({
    partnerId,
    groupId: partnerGroupData?.groupId,
    fYear,
    eltType: item.EltType,
  })

  const soldProducts =
    populatedData && populatedData.SoldProducts ? JSON.parse(populatedData.SoldProducts) : null

  const actualValueTypes = financialData?.AVTSettings?.ActualsValueTypes || defaultActualValueTypes

  const itemSettings: IELTDataSettings = {
    NetNdp:
      dataSettings.NetNdp && actualValueTypes.includes(dataSettings.NetNdp)
        ? dataSettings.NetNdp
        : financialData?.AVTSettings?.AVTDefault || defaultActualValueTypes[0],
    ActualsValueTypes: actualValueTypes,
    DisplayWarningForTypes: financialData?.AVTSettings?.DisplayWarningForTypes || [],
    WarningKey: financialData?.AVTSettings?.WarningKey || '',
  }

  const forceUpdatedFormData: TEltFormData = await getForceUpdatedDataFotDifferentEltType({
    formData,
    financialData,
    eltType: item.EltType,
    soldProducts,
    populatedMarkets: populatedData?.Markets || '',
    fYear,
    fQuarter,
    partnerId,
    actualValueTypes,
  })

  const itemPrefillData: Partial<IELTData> = {
    PartnerName: partnerGroupData?.groupName || companyName,
    PartnerId: partnerGroupData?.groupId ? null : partnerId,
    GroupId: partnerGroupData?.groupId ? partnerGroupData.groupId : null,
    FYear: fYear,
    FQuarter: fQuarter,
    Settings: JSON.stringify(itemSettings),
  }
  const sellThruSellToDescs: IForceUpdateData = {
    revenue: {
      SellThruDesc: financialData?.SellThruDesc || 'SellThru',
      SellToDesc: financialData?.SellToDesc || 'SellTo',
    },
  }

  return {
    forceUpdatedItem: {
      ...item,
      ...itemPrefillData,
    },
    forceUpdatedFormData: forceUpdatedFormData,
    sellThruSellToDescs,
  }
}
